import React from 'react';
import { FormControlLabelAndPopover } from '../FormControlLabel';
import { ValidationErrorsMessages } from '../FormValidation';

export const RadioButtonsControl = ({ field, handleChange, handleBlur, formDataEntry, errors } : ControlParameters) : JSX.Element => {

  return (
    <div className={`form-group ${field.properties?.fieldcssclass ?? ''}`} >
      <FormControlLabelAndPopover field={field} loading={formDataEntry.loading} />
      {field.settings.Options.split('\n').map(option => {
        const [value, label] = option.split(';');
        return (
          <div className={`custom-control custom-radio custom-control-inline ${field.settings.inputcontrolstyle !== undefined ? 'radio-button__' + field.settings.inputcontrolstyle : '' }` }>
            <input
              id={`${field["@column"]}-${value}`}
              key={`${field["@guid"]}-${value}`}
              className="custom-control-input"
              type="radio"
              name={field["@column"]}
              value={value}
              checked={formDataEntry?.value == value}
              onChange={handleChange}
              onBlur={handleBlur}
              autoComplete={field.settings.Autocomplete ?? "off"}
            />
            <label htmlFor={field["@column"] + "-" + value} className="custom-control-label">
              {label}
            </label>
          </div>
        );
      })}
       <ValidationErrorsMessages keyGuid={field["@guid"]} errors={errors} />
    </div>
  );
};